import { render, staticRenderFns } from "./mainbusinessPage5.vue?vue&type=template&id=79145b06&scoped=true&"
import script from "./mainbusinessPage5.vue?vue&type=script&lang=js&"
export * from "./mainbusinessPage5.vue?vue&type=script&lang=js&"
import style0 from "./mainbusinessPage5.vue?vue&type=style&index=0&id=79145b06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79145b06",
  null
  
)

export default component.exports